"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
exports.Tooltip = styled_components_1.default.a `
  position: relative;
  top: -1px;
  margin-right: 5px;
  color: ${props => props.color} !important;

  &:hover {
    cursor: pointer;
  }
`;
